var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18137_51237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 11.071 11.071 12.75 9 12.75C6.92893 12.75 5.25 11.071 5.25 9C5.25 6.92893 6.92893 5.25 9 5.25",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.65003C10.0153 1.55165 9.51367 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 8.48633 16.4483 7.98465 16.35 7.5",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02246 8.97228L12.4371 5.55761M14.805 3.25887L14.3901 1.76852C14.3137 1.52299 14.0183 1.42514 13.8192 1.58787C12.7421 2.46804 11.5688 3.65359 12.527 5.52355C14.4576 6.42382 15.5597 5.20979 16.4047 4.18938C16.5729 3.98636 16.4715 3.68116 16.2183 3.60794L14.805 3.25887Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18137_51237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIconBlack);
export default __webpack_public_path__ + "static/media/leads-icon-black.d37e4b242a425cb6f941a4fdf421e566.svg";
export { ForwardRef as ReactComponent };